import { ApiInstance } from '@/services/base'

export default {
    /**
     * Belirli bir işlem tipine göre tüm işlemleri getirir
     * @param {String} type - İşlem tipi (income veya expense)
     * @param {Object} params - Sorgu parametreleri (sayfa, arama, tarih aralığı vs.)
     * @returns {Promise} - API yanıtını içeren Promise
     */
    getTransactions(type, params = {}) {
        console.log('getTransactions API isteği gönderiliyor, parametreler:', params)
        return ApiInstance.get('/transactions/' + type, { params })
    },

    /**
     * Belirli bir işlem ID'sine göre detayları getirir
     * @param {Number} id - İşlem ID'si
     * @returns {Promise} - API yanıtını içeren Promise
     */
    getTransactionDetails(id, params = {}) {
        return ApiInstance.get('/transactions/' + id + '/details', { params })
    },

    /**
     * İşlem özeti verilerini getirir
     * @param {Object} params - Sorgu parametreleri (tarih aralığı vs.)
     * @returns {Promise} - API yanıtını içeren Promise
     */
    getTransactionsSummary(params = {}) {
        return ApiInstance.get('/transactions/summary', { params })
    },

    /**
     * Yeni bir işlem ekler
     * @param {Object} transaction - İşlem verileri
     * @returns {Promise} - API yanıtını içeren Promise
     */
    createTransaction(transaction) {
        return ApiInstance.post('/transactions', transaction)
    },

    /**
     * Var olan bir işlemi günceller
     * @param {Number} id - İşlem ID'si
     * @param {Object} transaction - Güncellenmiş işlem verileri
     * @returns {Promise} - API yanıtını içeren Promise
     */
    updateTransaction(id, transaction) {
        return ApiInstance.put('/transactions/' + id, transaction)
    },

    /**
     * Bir işlemi siler
     * @param {Number} id - İşlem ID'si
     * @returns {Promise} - API yanıtını içeren Promise
     */
    deleteTransaction(id) {
        return ApiInstance.delete('/transactions/' + id)
    },

    /**
     * İşlem kategorilerini getirir
     * @param {String} type - İşlem tipi (income veya expense)
     * @param {String} search - Aranacak kategori adı
     * @param {Boolean} all - Tüm sonuçları getirmek için
     * @returns {Promise} - API yanıtını içeren Promise
     */
    getCategories(type, search = '', all = false) {
        return ApiInstance.get('/transactions/categories', {
            params: {
                type,
                search,
                all,
            },
        })
    },
}
